import { getTCInFromPreviousSTorCP, getTCOutFromNextSTorCP } from "../../../../../../utils/checksubtitles";

// ***************************************************************************************
// onTakeTimeCodeVideoToTimeCodeInOrOutSubtitle()
// Prendre le time code de la vidéo et l'affecte au time code in ou out du sous-titre
// ***************************************************************************************
export function onTakeTimeCodeVideoToTimeCodeInOrOutSubtitle(key) {
  const { currentTimeCode } = this.props;

  // On historise
  this.addNewActionForUndo('onTakeTimeCodeVideoToTimeCodeInOrOutSubtitle');

  if (key === 'TAKETIMECODEVIDEOTOINSUBTITLE' || key === 'TAKEIN') {

    
    if (this.subtitle.out < currentTimeCode) {
      return;
    }

    this.subtitle.in = currentTimeCode;
  } else {

    if (this.subtitle.in > currentTimeCode) {
      return;
    }

    this.subtitle.out = currentTimeCode;
  }

  this.onChange();
}

export function onTakeTimeCodeToSubtitle(key) {
  switch (key) {
    case 'TAKETIMECODEOUTFROMPREVSUBTITLETOINCURRENTSUBTITLE':
      this.onTakeTimeCodeFromPrevSubtitleToCurrentSubtitle();
      break;
    case 'TAKETIMECODEINFROMNEXTSUBTITLETOOUTCURRENTSUBTITLE':
      this.onTakeTimeCodeFromNextSubtitleToCurrentSubtitle();
      break;

    default:
      return false;
  }
}

export function onTakeTimeCodeFromPrevSubtitleToCurrentSubtitle() {
  const prevSubtitle = this.props.subtitles[this.subtitle.id - 1];
  if (!prevSubtitle) {
    return;
  }

  // On historise
  this.addNewActionForUndo('onTakeTimeCodeFromPrevSubtitleToCurrentSubtitle');

  this.subtitle.in = getTCInFromPreviousSTorCP(
    this.subtitle,
    prevSubtitle,
    this.props.subtitleParameters
  );

  this.onChange();
}

export function onTakeTimeCodeFromNextSubtitleToCurrentSubtitle() {
  const nextSubtitle = this.props.subtitles[this.subtitle.id + 1];
  if (!nextSubtitle) {
    return;
  }

  // On historise
  this.addNewActionForUndo('onTakeTimeCodeFromNextSubtitleToCurrentSubtitle');

  this.subtitle.out = getTCOutFromNextSTorCP(
    this.subtitle,
    nextSubtitle,
    this.props.subtitleParameters
  );

  this.onChange();
}
